export default __webpack_public_path__ + "static/media/45.931046f6.jpeg";